import '@forest/native-diagnostics'

import { initializeNativeBridge } from '@forest/native-services'
import { appVersion, language } from '~/lib/params'
import { overwriteGetLocale, type Locale } from '~/paraglide/runtime'

overwriteGetLocale(() => language as Locale)

// appVersion is required: without it the facade treats the host as 0.0.0 and
// every version-gated call (getServiceLevel, ≥ 5.27.0) reports unsupported.
// pageReady is the App's bootstrap outcome, not called here.
initializeNativeBridge({
  appVersion,
  bifrost: { enableDebug: import.meta.env.MODE !== 'production' },
})
